module.exports = __webpack_public_path__ + "media/images/app/toast/success-a8b9266df14b4efafd5b8d76db5ba262.svg";